<template>
  <AccountOpePanel>
    <div class="aiz-titlebar mt-2 mb-4">
      <div class="h6">
        <span>{{ $t("对话") }}</span>
        <a v-if="userShop" href="javascript:void(0)" @click="goto(`/shop?shopId=${userShop.id}`)">
          {{ userShop.name }}
        </a>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h5 class="card-title fs-16 fw-600 mb-0">#{{ group.no }}</h5>
      </div>

      <div class="card-body">
        <ul class="list-group list-group-flush">
          <li v-for="item in chatGroupRecords" :key="item.id" :class="`list-group-item px-0 ${item.memberId===myMember.id?'text-right':''}`">
            <div v-if="memberMap[item.memberId]" class="mb-2">
              <span class="mr-4" v-show="item.memberId===myMember.id && (readDate(item.createTime) > addMinute(new Date(),-1)) && !item.rollbackFlag" @click="toDelete(item)">{{ $t('删除') }}</span>
              <img
                    :src="getFileViewUrl(memberMap[item.memberId].pic)"
                    class="avatar avatar-xs"
                />
              <div class="media-body">
                <h6 class="mb-0 fw-600">
                  {{ memberMap[item.memberId].nickName }}
                </h6>
                <p class="opacity-50">{{ item.createTime }}</p>
              </div>
            </div>
            <p v-if="item.rollbackFlag">
               {{ $t('消息已撤回') }}
             </p>
             <p v-else>
               {{ item.content }}
             </p>
          </li>
        </ul>
        <el-pagination
            layout="prev, pager, next"
            :total="total"
            :page-size="pageSize"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
        >
        </el-pagination>
<!--        chatGroupRecord={{chatGroupRecord}}-->
        <van-form class="pt-4" @submit="submit">
          <div class="form-group">
            <van-field
                v-model="consultContent"
                :placeholder="$t('输入您的回复')"
                class="form-control"
                name="message"
                :rules="[{ required: true, message: $t(`please_input`) }]"
                type="textarea"
                rows="4"
                autosize
                @keyup.enter.native="submit"
            ></van-field>
          </div>
          <div class="form-group mb-0 text-right">
            <van-button
                v-loading="loading"
                :loading-text="$t('submitting')"
                class="btn btn-primary"
                native-type="submit"
            >
              {{ $t("submit") }}
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
  </AccountOpePanel>
</template>
<script>
import AccountOpePanel from "@/components/AccountOpePanel.vue";
import {addMinute} from "@/utils/dateUtil";
import {listToMap} from "@/utils/collUtil";

export default {
  components: {
    AccountOpePanel
  },
  data() {
    return {
      groupId: null,
      group: {},
      memberMap: {},
      myMember: {},
      otherMember: {},

      chatGroupRecords: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,

      loading: false,
      consultContent: null,
      timestamp: null,
    };
  },
  watch: {
    'chatGroupRecord': {
      handler(newVal, oldVal) {
        this.getChatGroupRecordPage();
        if (newVal.timestamp === this.timestamp) {
          this.loading = false
          this.consultContent = null;
          this.$toast.success(this.$t("Commit_Success"));
          this.timestamp = new Date().getTime()
        }
      },
      deep: true
    },
  },
  computed: {
    ...Vuex.mapGetters([
      'chatUnread',
      'chatGroupLastChange',
      'chatGroupRecord',
    ]),
    userShop() {
      return this.otherMember && this.otherMember.extendJson && JSON.parse(this.otherMember.extendJson).userShop
    },
  },
  created() {
    this.groupId = this.$route.query.groupId
    this.initChatGroup();
    this.getChatGroupRecordPage();
  },
  methods: {
    addMinute,
    submit() {
      this.loading = true;
      this.timestamp = new Date().getTime() + ''
      this.$post("/user/chatGroupRecord/save", {
        timestamp: this.timestamp,
        content: this.consultContent,
        groupId: this.groupId,
      })
          .then(() => {

          })
          .finally(() => {
          });
    },
    toDelete(entity) {
      this.loading = true;
      this.$post(`/user/chatGroupRecord/delete/${entity.id}`)
          .then(() => {
            this.$toast.success(this.$t("删除成功"));
            this.getChatGroupRecordPage();
          })
          .finally(() => {
            this.loading = false;
          });
    },
    async getChatGroupRecordPage() {
      const params = {
        groupId: this.groupId,
        curPage: this.currentPage,
        pageSize: this.pageSize
      };
      const res = await this.$get("/user/chatGroupRecord/page", {params});
      this.total = parseInt(res.data.total);
      const records = res.data.records.reverse();
      this.chatGroupRecords = records
    },
    handleCurrentChange() {
      this.getChatGroupRecordPage();
    },
    async initChatGroup() {
      const groupId = this.groupId;
      this.group = (await this.$post("/user/chatGroup/init", {groupId})).data
      const members = this.group.chatGroup_chatGroupMember;
      this.memberMap = listToMap(members,'id')
      this.myMember = members.filter(m => {
        return m.userId === this.userInfo.id && m.type === 'user'
      })[0]
      this.otherMember = members.filter(m => {
        return m !== this.myMember
      })[0]
    },
  },
};
</script>
